import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import host from '../../urlPath';
//******* 
 

 

//=---------- READ
export const showMessageLogData = createAsyncThunk("showMessageLogData", async (scheduledt, { rejectWithValue }) => {

        const response = await fetch(`${host}/msg_log_file.php`, {
        method: "GET", // *GET, POST, PUT, DELETE, etc. 
        headers: {
            "Content-Type": "application/json"
        }
    });
    try {
        const result = await response.json();
        return result;

    } catch (error) {
        return rejectWithValue(error)
    }
})
 

//*************************************** FOR API END *************************


export const msgLog = createSlice({
    name: "msgLog",
    initialState: {
        messageLogData: [], 
        loading: false,
        error: null, 
    },
 
 
    //*************************************** FOR API START *************************
    extraReducers: (builder) => { 
 

        //---------------------- FOR SELECT ---------------------------
        builder.addCase(showMessageLogData.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(showMessageLogData.fulfilled, (state, action) => {
            state.loading = false; 
            state.messageLogData = action.payload 
            //console.log(action.payload)
        })
        builder.addCase(showMessageLogData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------
 

        //*************************************** FOR API END ************************* 
    },

});
export default msgLog.reducer; 